import { create } from 'zustand';

export interface AuthUser {
  email: string;
  role: string;
}

interface AuthState {
  user: AuthUser | null;
  setUser: (user: AuthUser | null) => void;
  signOut: () => void;
}

const getInitialUser = (): AuthUser | null => {
  try {
    // authToken is managed by LoginModal and when API calls are made,
    // but its presence can be a good indicator for attempting to load user.
    const token = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('authUser'); 
    if (token && storedUser) {
      // Optional: Decode token to verify expiry if not handled by backend/interceptor
      // For now, trust that if 'authUser' and 'authToken' exist, the user is "logged in"
      return JSON.parse(storedUser) as AuthUser;
    }
    return null;
  } catch (error) {
    console.error("Error loading user from localStorage:", error);
    // If there's an error, clear potentially corrupted stored items
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    return null;
  }
};

export const useAuthStore = create<AuthState>((set) => ({
  user: getInitialUser(), // Initialize user state
  setUser: (user: AuthUser | null) => {
    set({ user });
    if (user) {
      localStorage.setItem('authUser', JSON.stringify(user)); // Store user info on setUser
    } else {
      localStorage.removeItem('authUser'); // Clear user info on setUser(null)
    }
  },
  signOut: () => {
    set({ user: null });
    localStorage.removeItem('authToken'); // Ensure token is removed
    localStorage.removeItem('authUser'); // Clear both token and user info
  },
}));
